<ng-container *ngIf="!isNewKeplerMatch; else editorMatch">
  <ng-container *ngIf="matchKeplerList && !matchKeplerList?.docs?.length; else matchList">
    <div class="main__void">
      <div class="main__void--icon">
        <span class="glicon-play-game"></span>
      </div>
      <span class="main__void--title">{{ 'kepler.matchVoidTitle' | translate }}</span>
      <span class="main__void--subtitle">{{ 'kepler.matchVoidSubtitle' | translate }}</span>
      <gl-button
        *lmsProfileGuard="'kepler.create'"
        color-primary
        [text]="'kepler.addMatch' | translate"
        title="{{ 'kepler.addMatch' | translate }}"
        (onClick)="goEditorKepler()"
      ></gl-button>
    </div>
  </ng-container>

  <ng-template #matchList>
    <lms-toolbar [options]="toolbarConfig">
      <div class="lms-toolbar__item" *lmsProfileGuard="'kepler.create'" tools-actions>
        <gl-button
          color-primary
          title="{{ 'kepler.addMatch' | translate }}"
          [text]="'kepler.addMatch' | translate"
          (onClick)="goEditorKepler()"
        ></gl-button>
      </div>
    </lms-toolbar>

    <lms-kepler-match-list
      [listId]="clientKeplerMatchListId"
      [clientId]="client.id"
      [matchList]="matchKeplerList"
    ></lms-kepler-match-list>
  </ng-template>
</ng-container>
<ng-template #editorMatch>
  <lms-kepler-editor [client]="client" (submit)="saveMatch($event)">
    <gl-button
      color-secondary
      [text]="'actions.cancel' | translate"
      (onClick)="goKeplerList()"
      form-actions-before
    ></gl-button>
  </lms-kepler-editor>
</ng-template>
